import UAParser from 'ua-parser-js';
import isInDesktopView from './isInDesktopView';

const uaParser = new UAParser();

export default function shouldRedirectToDesktopView() {
  return isDesktop() && ! isInDesktopView();
}

function isDesktop() {
  const device = uaParser.getDevice();

  // @see https://github.com/faisalman/ua-parser-js/issues/224#issuecomment-282257256
  // "Device types for desktops will always be "undefined" because unlink other
  // devices, they're not explicitly included inside the UserAgent"
  if (device.type === undefined) {
    return true;
  }

  return (
    device.type !== 'tablet' &&
    device.type !== 'mobile'
  );
}
